import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import getters from './getters'
import CommonStore from './Common/index';
import AdminStore from './Admin/index';

Vue.use(Vuex)

const state = {
  ...CommonStore.state,
  ...AdminStore.state,
};

// getters
const globalGetter = {
  ...CommonStore.getters,
  ...AdminStore.getters,
};

// mutations
const mutations = {
  ...CommonStore.mutations,
  ...AdminStore.mutations,
};

const modules = {
  ...CommonStore.modules,
  ...AdminStore.modules,
};


export default new Vuex.Store({
  modules: {
    app,
    errorLog,
    permission,
    tagsView,
    user,
    ...modules

  },
  getters: {
    ...getters,
    ...globalGetter
  },
  mutations,
  state,
  //strict: true
})




// WEBPACK FOOTER //
// ./src/store/index.js